
import register from './register'
import confirmBooking from './confirmBooking'
export default {
  register,
  confirmBooking
}



// WEBPACK FOOTER //
// ./src/components/Martech2026/index.js